import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const PUBS = [
  { img: '/images/Structural-Analysis-I_Study-Material_Somayya-Academy-Pu_002.jpeg',    title: 'Structural Analysis I' },
  { img: '/images/Structural-Analysis-II_Study-Material_Somayya-Academy-P_002.jpeg',   title: 'Structural Analysis II' },
  { img: '/images/Structural-Design-I_Study-Material_Somayya-Academy-Pune_002.jpeg',   title: 'Structural Design I' },
  {
    img: '/images/Structural-Design-III_Study-Material_Somayya-Academy-Pune-Kothrud_Best-Coaching-Classes-in-Pune-Kothrud-copy.009-786x1024.jpeg',
    title: 'Structural Design II',
  },
  {
    img: '/images/Structural-Design-I_Study-Material_Somayya-Academy-Pune-Kothrud_Best-Coaching-Classes-in-Pune-Kothrud-copy.010-786x1024.jpeg',
    title: 'Structural Design III',
  },
  {
    img: '/images/Engineering-Mechanics-1_Somayya-Academy_Best-Engineering-Coaching-Classes-in-Pune_Best-Engineering-Classes-in-Pune-Kothrud-786x1024.jpg',
    title: 'Engineering Mechanics I',
  },
  {
    img: '/images/Strength-of-Machine-Elements_Somayya-Academy_Best-Engineering-Coaching-Classes-in-Pune_Best-Engineering-Classes-in-Pune-Kothrud-786x1024.jpg',
    title: 'Strength of Machine Elements',
  },
];

export default function PublicationsSection() {
  return (
    <section className="sa-publications">
      <div className="sa-container">

        {/* Header row: title left, nav arrows right */}
        <div className="sa-pub-header">
          <h2 className="sa-section-title" style={{ marginBottom: 0 }}>Our Publications</h2>
          <div className="sa-pub-nav">
            <button className="sa-pub-prev sa-swiper-btn" aria-label="Previous">&#8592;</button>
            <button className="sa-pub-next sa-swiper-btn" aria-label="Next">&#8594;</button>
          </div>
        </div>

        <Swiper
          modules={[Navigation, Autoplay]}
          navigation={{
            prevEl: '.sa-pub-prev',
            nextEl: '.sa-pub-next',
          }}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          speed={800}          /* smooth 800ms transition — matches original smartSpeed:2000 feel */
          loop={true}
          spaceBetween={30}
          breakpoints={{
            0:   { slidesPerView: 1 },
            576: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            992: { slidesPerView: 4 },
          }}
        >
          {PUBS.map(pub => (
            <SwiperSlide key={pub.title}>
              <div className="sa-pub-card">
                <div className="sa-pub-img-wrapper">
                  <img src={pub.img} alt={pub.title} loading="lazy" />
                </div>
                <div className="sa-pub-card-body">
                  <h3><a href="#">{pub.title}</a></h3>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

      </div>
    </section>
  );
}
